import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import LayoutOne from "../layouts";
import Breadcrumb from "../components/UI/breadcrumb";

const About = () => {
    return (
        <Fragment>
            <MetaTags>
                <title>Adaptive Systems LLC | Disclaimer</title>
                <meta
                    name="description"
                    content=""
                />
            </MetaTags>
            <LayoutOne>
                <Breadcrumb title="Disclaimer" />

                <div className="container pt--60 pb--60">
                   <p>The information provided by Adaptive Systems LLC is for general informational purposes only. We make no representations or warranties of any kind, express or implied, regarding the accuracy, reliability, or completeness of the content on our website or within our services. Use of our services is at your own risk. We are not responsible for any damages or losses resulting from the use of our services, including but not limited to service interruptions, data loss, or unauthorized access to your account. By using our services, you agree to comply with all applicable laws and the terms outlined in our Terms of Service and Privacy Policy.</p>
                </div>
            </LayoutOne>
        </Fragment>
    );
};

export default About;
